import {
  ICandidate,
  ITag,
  INote,
  IApplicationClickInfo,
} from '../../../interfaces/graph-types';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CandidateService } from '../../../services/candidate.service';
import { Subject, Observable } from 'rxjs';
import { WatchAccountService } from '../../../services/watch-account.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalFunnelSelectorComponent } from '../../modals/funnel-selector/modal-funnel-selector.component';
import { AccountService } from '../../../services/account.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'candidate-info',
  template: require('./candidate-info.component.pug'),
  styles: [require('./candidate-info.component.css').toString()],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateInfoComponent implements OnInit {
  @Input()
  candidateSubjectId: Subject<string>;

  @Input()
  accountId: string;
  @Output()
  onClose = new EventEmitter();
  @Output()
  onCandidateDelete = new EventEmitter();

  candidate: ICandidate = null;
  companyId$: Subject<string>;

  sub: any = null;
  prosub: any = null;

  rightPercent = '-65%';
  backdrop = 'none';
  phone = null;

  bsModalRef: BsModalRef;

  addNoteForm: FormGroup;
  errorNoteMessage?: string;
  isUpdating = false;

  notes$: Observable<INote[]>;

  emailVerificationOptions = {
    '-1': {
      value: 'invalid',
      tooltip: 'Email has been flagged as invalid',
      class: { 'badge-danger': true },
    },
    '1': {
      value: 'valid',
      tooltip: 'Email has been flagged as valid',
      class: { 'badge-success': true },
    },
    '2': {
      value: 'risky',
      tooltip: 'Email has been flagged as risky. Send at your own risk.',
      class: { 'badge-warning': true },
    },
    '3': {
      value: 'unknown validity',
      tooltip: 'Email address validity is unknown',
      class: { 'badge-dark': true },
    },
  };

  // -------------------------------------------------------------------
  constructor(
    private candidateService: CandidateService,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    this.companyId$ = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.addNoteForm = this.formBuilder.group({
      content: '',
    });

    this.sub = this.candidateSubjectId.subscribe(newCandidateId => {
      this.leadLoadingError = undefined;

      if (newCandidateId == null) {
        this.rightPercent = '-65%';
        this.backdrop = 'none';
      } else {
        this.candidate = null;
        if (this.prosub) {
          this.prosub.unsubscribe();
        }
        this.prosub = this.candidateService
          .getCandidateInfo(this.accountId, newCandidateId)
          .subscribe(response => {
            this.candidate = response;
            this.phone = this.candidate.phone;
            // this.cdr.detectChanges();
          });

        this.notes$ = this.candidateService.notes(newCandidateId);

        this.rightPercent = '0%';
        this.backdrop = 'block';
      }
      // this.cdr.detectChanges(); // to enable sliding window to be VRDisplayCapabilities, otherwise we'll have to wait the return from the server to slide the window
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.prosub) {
      this.prosub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  clickclose() {
    this.candidateSubjectId.next(null);

    if (this.onClose) {
      this.onClose.emit();
    }
  }

  // -------------------------------------------------------------------
  funnelURL(id) {
    return `/account/${this.watchAccount.accountId().getValue()}/funnels/${id}`;
  }

  // -------------------------------------------------------------------
  addToFunnel() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.watchAccount.accountId().getValue(), //response.organization.id,
      onSelect: this.onFunnelSelected.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalFunnelSelectorComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  onFunnelSelected(funnelId: string, onfailure: onSmartFailure) {
    this.accountService.addCandidatesToFunnel(
      funnelId,
      [this.candidate.id],
      null,
      () => {
        this.bsModalRef.hide();
      },
      error => {
        onfailure(error);
      },
    );
  }

  isLeadLoading = false;
  leadLoadingError?: string;

  // -------------------------------------------------------------------
  setAsLead(value: boolean) {
    this.isLeadLoading = true;
    this.leadLoadingError = undefined;
    this.candidateService.setAsLead(
      [this.candidate.id],
      value,
      () => {
        this.isLeadLoading = false;
        this.candidate.isLead = value;
      },
      error => {
        this.leadLoadingError = error;
        this.isLeadLoading = false;
      },
    );
  }

  doNotContactLoading = false;

  // -------------------------------------------------------------------
  setAsDoNotContact(value: boolean) {
    this.doNotContactLoading = true;
    this.candidateService.doNotContactCandidates(
      [this.candidate.id],
      value,
      () => {
        this.doNotContactLoading = false;
        this.candidate.doNotContact = value;
      },
      error => {
        this.doNotContactLoading = false;
      },
    );
  }

  // -------------------------------------------------------------------
  deleteCandidate(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.candidateService.deleteCandidates(
      [this.candidate.id],
      () => {
        data.hide = true;
        console.warn({ data });
        this.clickclose();
        onsuccess();
        if (this.onCandidateDelete) this.onCandidateDelete.emit();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  tagging(tag: ITag, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    console.log('* TAGGING ' + tag.name);
    this.candidateService.setTag(
      this.watchAccount.accountId().getValue(),
      this.candidate.id,
      tag.id,
      !tag.value,
      () => {
        //tag.value = !tag.value;
        console.log('* SUCCESS ' + tag.name);
        onsuccess();
      },
      error => {
        console.log('* ERROR ' + tag.name);
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  hideAvatar(company) {
    company.avatarUrl = null;
  }

  viewingCompany: string;
  // -------------------------------------------------------------------
  selectCompanyInfo(company) {
    this.viewingCompany = company.id;
    this.companyId$.next(company.id);
  }

  // -------------------------------------------------------------------
  closeCompanyInfo() {
    this.viewingCompany = null;
  }

  // -------------------------------------------------------------------
  changeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    if (data == 'phone') {
      this.phone = newValue;
    }

    this.candidateService.setField(
      this.candidate.id,
      data,
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  changeAttributeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.candidateService.setAttributeField(
      this.candidate.id,
      data.id,
      data.attributeValueId,
      'value',
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
    //console.warn(this.candidate);
  }

  // -------------------------------------------------------------------
  onSubmit({ content }: { content: string }) {
    this.isUpdating = true;
    this.errorNoteMessage = undefined;
    this.candidateService.addNote(
      this.candidate.id,
      content,
      () => {
        this.addNoteForm.controls.content.setValue('');
        this.isUpdating = false;
      },
      error => {
        this.isUpdating = false;
        this.errorNoteMessage = error;
      },
    );
  }

  // -------------------------------------------------------------------
  deleteNote(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.candidateService.deleteNote(
      this.candidate.id,
      data.id,
      res => {
        // onsuccess(); we don't stop the spinning and wait for the reload to happen
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  mouseEnter(day, index) {}

  // -------------------------------------------------------------------
  mouseLeave() {}

  // -------------------------------------------------------------------
  getPhoneCompact() {
    let compact = this.phone.replace(/[^0-9\+]/g, '');
    return compact;
  }

  // -------------------------------------------------------------------
  clickToCall(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.accountService.clickToCall(
      this.accountId,
      this.phone,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
